import * as React from "react";
import {
  Pagination,
  List,
  Datagrid,
  TextField,
  TextInput,
  FunctionField,
  ReferenceInput,
  SelectInput,
  downloadCSV,
  DateField,
  DateInput,
} from "react-admin";
import { Button } from "@material-ui/core";
import jsonExport from "jsonexport/dist";
import VisibilityIcon from '@material-ui/icons/Visibility';
import CMLoggingViewModal from "./CMLoggingViewModal";
import moment from "moment";

const cmAccountsFilters = [
  <DateInput source="date@_gte" label="From" alwaysOn resettable />,
  <DateInput source="date@_lte" label="To" alwaysOn resettable />,
  <TextInput label="Message" source="message" alwaysOn resettable />,
  <ReferenceInput
    style={{ width: 250 }}
    label="Type"
    source="type"
    reference="e_cm_logging_types"
    alwaysOn
    resettable
  >
    <SelectInput optionText="comment" />
  </ReferenceInput>,
];

const exporter = (records) => {
  const forExport = records.map((record) => {
    return {
      id: record.id,
      tenant: record.tenant_id,
      date: record.date,
      type: record.type,
      message: record.message,
    };
  });
  jsonExport(
    forExport,
    {
      headers: ["id", "tenant_id", "date", "type", "message"],
    },
    (err, csv) => {
      downloadCSV(csv, "cm_logging");
    }
  );
};

const CMLoggingList = (props) => {
  const [openModal, setOpenModal] = React.useState(false);
  const [selectedRecord, setSelectedRecord] = React.useState(null);

  const handleViewClick = (record) => {
    setSelectedRecord(record);
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setSelectedRecord(null);
  };

  return (
    <>
      <List
        pagination={<Pagination rowsPerPageOptions={[25, 50, 100]} />}
        sort={{ field: "date", order: "Desc" }}
        filters={cmAccountsFilters}
        bulkActionButtons={false}
        exporter={exporter}
        {...props}
      >
        <Datagrid>
          <TextField source="tenant.tenant_group.name" label="Tenant Group" />
          <TextField source="tenant.name" label="Property" />
          <FunctionField
            label="Date"
            render={record => moment.utc(record.date).local().format("YYYY-MM-DD HH:mm:ss")}
          />
          <TextField source="type" label="Type" />
          <TextField source="message" label="Message" />
          <FunctionField
            label="Actions"
            render={(record) => (
              <Button
                color="primary"
                variant="text"
                size="small"
                startIcon={<VisibilityIcon />}
                onClick={() => handleViewClick(record)}
              >
                View
              </Button>
            )}
          />
        </Datagrid>
      </List>

      <CMLoggingViewModal
        open={openModal}
        onClose={handleCloseModal}
        record={selectedRecord}
      />
    </>
  );
};

export default CMLoggingList;
